import { MantineTheme } from '@mantine/core';
import { useMemo } from 'react';

import { defaultActivityThemeStyles } from 'external-modules/ui';
import { ActivityThemeStyles } from 'shared/types/Theme';

import { DEFAULT_THEME } from './_mantineClone/defaultTheme';
import { deepMerge, mergeMantineTheme } from './_mantineClone/mergeMantineTheme';
import { themeToStyles } from './themeToStyles';
import { theme } from '@/utils/theme.utils';

export const useThemeStyles = (currentActivityTheme: ActivityThemeStyles) => {
  return useMemo(
    () =>
      themeToStyles(
        mergeMantineTheme(DEFAULT_THEME, {
          ...theme,
          other: deepMerge(defaultActivityThemeStyles, currentActivityTheme)
        }) as MantineTheme & {
          other: ActivityThemeStyles;
        }
      ),
    [currentActivityTheme]
  );
};
